import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import classnames from 'classnames';

import LogoNav from 'dibs-logo/exports/LogoNav.ts';
import { UserNotifications } from '../Notifications/userNotifications/UserNotifications.tsx';
import { SearchBar } from '../SearchBar/SearchBar.tsx';
import AccountNav from '../AccountNav/AccountNav.tsx';
import Favorites from '../Favorites/Favorites.tsx';
import CartNav from '../CartNav/CartNav.jsx';
import { useHeaderFooterServerVars } from '../HeaderFooterServerVarsContext/HeaderFooterServerVarsContext.tsx';

import dibsCss from 'dibs-css';
import styles from './TopBar-style.scss';

const TopBarComponent = props => {
    const {
        hasRootPendingRefetch,
        hasUserId,
        hasUser,
        isClient,
        user,
        userId,
        viewer,
        onMouseOver,
        onMouseOut,
        hasError,
        isSticky,
        hasTradeUserId,
    } = props;
    const barClasses = classnames(styles.bar, dibsCss.zBump, {
        [styles.stickyBar]: isSticky,
    });
    const { isHeaderFullWidth } = useHeaderFooterServerVars();
    const isEmailOnly = !!user?.authMetadata?.emailOnly;
    const { isUserTypeTrade, isUserTypeVip } = useHeaderFooterServerVars();

    if (hasError) {
        return (
            <div className={barClasses}>
                <div
                    className={classnames(styles.barContent, dibsCss.flex, dibsCss.justifyBetween)}
                >
                    <div
                        className={classnames(
                            dibsCss.flex,
                            dibsCss.itemsCenter,
                            dibsCss.grow,
                            dibsCss.shrink,
                            dibsCss.basis0
                        )}
                    >
                        <LogoNav
                            user={user}
                            isUserTypeTrade={isUserTypeTrade}
                            isUserTypeVip={isUserTypeVip}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        <div className={barClasses} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            <div
                className={classnames(styles.barContent, dibsCss.flex, dibsCss.justifyBetween, {
                    [dibsCss.ptXsmall]: !isSticky,
                    [styles.isFullWidth]: isHeaderFullWidth,
                })}
                data-tn="main-nav-top"
            >
                <LogoNav
                    user={user}
                    isUserTypeTrade={isUserTypeTrade}
                    isUserTypeVip={isUserTypeVip}
                    isStickyLogo={isSticky}
                />
                <div className={classnames(dibsCss.wFull, dibsCss.mxLarger, dibsCss.mrSmall)}>
                    <SearchBar
                        viewer={viewer}
                        user={user}
                        isClient={isClient}
                        hasRootPendingRefetch={hasRootPendingRefetch}
                    />
                </div>
                <div
                    className={classnames(
                        styles.rightContainer,
                        dibsCss.flex,
                        dibsCss.justifyEnd,
                        dibsCss.itemsCenter,
                        dibsCss.grow,
                        dibsCss.shrink0,
                        styles.basis261
                    )}
                >
                    <AccountNav
                        isClient={isClient}
                        hasUser={hasUser}
                        hasUserId={hasUserId}
                        user={user}
                        hasTradeUserId={hasTradeUserId}
                        viewer={viewer}
                        hasRootPendingRefetch={hasRootPendingRefetch}
                    />
                    {!isEmailOnly && userId && isClient && (
                        <UserNotifications
                            userId={userId}
                            hasTradeUserId={hasTradeUserId}
                            hasRootPendingRefetch={hasRootPendingRefetch}
                        />
                    )}
                    <Favorites
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        isClient={isClient}
                        userId={userId}
                    />
                    <CartNav
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        isClient={isClient}
                        user={user}
                        userId={userId}
                        viewer={viewer}
                    />
                </div>
            </div>
        </div>
    );
};

TopBarComponent.propTypes = {
    hasError: PropTypes.bool,
    hasRootPendingRefetch: PropTypes.bool,
    hasUser: PropTypes.bool,
    hasUserId: PropTypes.bool,
    isClient: PropTypes.bool,
    openDrawer: PropTypes.func,
    user: PropTypes.object,
    userId: PropTypes.string,
    viewer: PropTypes.object,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    isSticky: PropTypes.bool,
    hasTradeUserId: PropTypes.bool,
};

export const TopBar = createFragmentContainer(TopBarComponent, {
    viewer: graphql`
        fragment TopBar_viewer on Viewer {
            ...CartNav_viewer
            ...SearchBar_viewer
            ...AccountNav_viewer
        }
    `,

    user: graphql`
        fragment TopBar_user on User {
            ... @include(if: $isClient) {
                ...AccountNav_user
                ...CartNav_user
                ...SearchBar_user
                ...LogoNav_user
                authMetadata {
                    emailOnly
                }
            }
        }
    `,
});
